import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import SEO from "../components/seo/SEO";

export default function PaymentCancel() {
  return (
    <>
      <SEO title="Checkout cancelled — MyFinancesGuru Tools" description="Your checkout was cancelled." path="/payment/cancel" noindex />
      <div className="mx-auto max-w-2xl px-4 py-20 text-center sm:px-6" data-testid="payment-cancel">
        <XCircle className="mx-auto h-12 w-12 text-muted-foreground" />
        <h1 className="mt-6 font-heading text-3xl font-bold text-foreground">Checkout cancelled</h1>
        <p className="mt-3 text-muted-foreground">No charge was made. Whenever you're ready, your planners are waiting.</p>
        <Link to="/products" className="mt-8 inline-flex rounded-full bg-action px-6 py-3 text-sm font-semibold text-white hover:bg-action-hover">
          Back to products
        </Link>
      </div>
    </>
  );
}
